export default "__VITE_ASSET__C9jpAoai__"